module.exports = __webpack_public_path__ + "static/media/twitter.48ff7eb6.png";